import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface appState {
    modalSuccess:boolean;
    modalErrorMessage:boolean;
    isLoading: boolean;
    preloader:boolean;
    error: string;
    errorCode: string;
    successCode: string;
    successMessage: string;
    successMessageError: string;
}

const initialState: appState = {
    modalSuccess: false,
    modalErrorMessage:false,
    preloader:true,
    isLoading: false,
    error: '',
    errorCode: '',
    successCode: '',
    successMessage: '',
    successMessageError: ""
};


const appSlice = createSlice({
    name:'appSlice',
    initialState,
    reducers:{
        changeModalSuccess(state,action){
            state.modalSuccess = action.payload;
        },
        changeModalErrorMessage(state,action){
            state.modalErrorMessage = action.payload;
        },
        changePreloader(state,action){
            state.preloader = action.payload;
        }
    },
    extraReducers: (builder:any) => {

    },
});
export const {} = appSlice.actions;
export default appSlice.reducer;